module.exports = __webpack_public_path__ + "static/york-college-staff-b6e8b9456a4105c2761e8a247fdb50f7.jpg";